import { coerce, integer, string } from 'superstruct';
export const Integer = coerce(integer(), string(), function(value) {
    return parseInt(value, 10);
});
